import { ExpandMore } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Grid, Stack, Typography } from "@mui/material";
import { accordionExpandedState, isOfferState } from "../../recoil";
import { FormTextField } from "../../../../components/fields";
import { IFormValues } from "../../types";
import { useRecoilState } from "recoil";
import { useTranslation } from "react-i18next";
import BillingCountryField from "../invoice/_component/BillingCountryField";
import BillingProvinceField from "../invoice/_component/BillingProvinceField";

export const BillingAddressDetails = () => {
    const { t } = useTranslation('booking');

    const [isOffer] = useRecoilState(isOfferState);
    const [billingAddressExpanded, setBillingAddressExpanded] = useRecoilState(accordionExpandedState('billingAddress'));

    function getBillingAddressForm() {
        return <>
            <Grid container rowSpacing={1} columnSpacing={3}>
                <Grid container item xs={12} sm={6} columnSpacing={1}>
                    <BillingCountryField billingCountryDisabled={false} />
                    {/*
                    <FormAutocomplete<IFormValues>
                        name="invoice.billingCountry"
                        label={t("invoice.billingCountry") + '*'}
                        options={countriesList?.map((c: any) => c.code).sort()}
                        isOptionEqualToValue={(option: any, value: any) => option?.code === value?.code}
                        getOptionLabel={(opt: any) => opt.code}
                    />
                    */}
                </Grid>
                <Grid container item xs={12} sm={6} columnSpacing={1}>
                    <BillingProvinceField billingProvinceDisabled={false} />
                    {/*<FormAutocomplete<IFormValues>
                        name="invoice.billingProvince"
                        label={t("invoice.billingProvince") + (billingCountry !== "IT" ? '' : '*')}
                        options={provincesQuery.data?.response ?? []}
                        loading={provincesQuery.isInitialLoading}
                        isOptionEqualToValue={(option: any, value: any) => option?.codeProvince === value?.codeProvince}
                        getOptionLabel={(opt: any) => opt.description}
                    />*/}
                </Grid>
                <Grid container item xs={12} sm={6} columnSpacing={1}>
                    <FormTextField<IFormValues>
                        name="invoice.billingCity"
                        label={t("invoice.billingCity")}
                    />
                </Grid>
                <Grid container item xs={12} sm={6} columnSpacing={1}>
                    <FormTextField<IFormValues>
                        name="invoice.billingPostalCode"
                        label={t("invoice.billingPostalCode")}
                    />
                </Grid>
                <Grid container item xs={12} sm={6} columnSpacing={1}>
                    <FormTextField<IFormValues>
                        name="invoice.billingStreetName"
                        label={t("invoice.billingStreetName")}
                    />
                </Grid>
                <Grid container item xs={12} sm={6} columnSpacing={1}>
                    <FormTextField<IFormValues>
                        name="invoice.billingStreetNumber"
                        label={t("invoice.billingStreetNumber")}
                    />
                </Grid>
                {/*
                <Grid container item xs={12} sm={6} columnSpacing={1}>
                    <FormTextField<IFormValues>
                        name="invoice.certifiedEmail"
                        label={t("invoice.certifiedEmail") + ' *'}
                    />
                </Grid>
                */}
            </Grid>
        </>
    }

    return (
        isOffer ?
            <Accordion expanded={billingAddressExpanded} onChange={(e, expanded) => setBillingAddressExpanded(expanded)}>
                <AccordionSummary expandIcon={<ExpandMore />} sx={{
                    '.MuiAccordionSummary-content': {
                        justifyContent: "space-between",
                        alignItems: "center"
                    }
                }} >
                    <Stack
                        direction="row"
                        alignItems="center"
                        columnGap={2}
                    >
                        <Typography variant="h5">
                            {t('label.billingAddress')}
                        </Typography>
                    </Stack>
                </AccordionSummary>
                <AccordionDetails>
                    {getBillingAddressForm()}
                </AccordionDetails>
            </Accordion> : <></>
    )
}
